import { render, staticRenderFns } from "./storicoMovimenti.vue?vue&type=template&id=2841ec12"
import script from "./storicoMovimenti.vue?vue&type=script&lang=js"
export * from "./storicoMovimenti.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports